import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import { Typography } from 'antd'

import { icons, SmallSpinner } from 'portal/lib/primitives'
import * as routes from 'portal/routes'
import { datePickerChanged } from 'portal/store/global/actions'
import { loadRecordsCount } from 'portal/store/home/actions'

import {
  Tile,
  TileNumber,
  TileRow,
  Tiles,
  TitleBar,
  TitleBarIcon
} from './commonStyles'
import moment from 'moment'

export const Waste = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()

  const { Title } = Typography

  const userUuid = useSelector((state: any) => state.auth.userUuid)

  useEffect(() => {
    if (accountId && projectId) {
      dispatch(loadRecordsCount(accountId, projectId, 'waste', 'total', {}))
      dispatch(loadRecordsCount(accountId, projectId, 'waste', 'today', {}))
      dispatch(
        loadRecordsCount(accountId, projectId, 'waste', 'last30Days', {})
      )
    }
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    if (accountId && projectId && userUuid) {
      dispatch(
        loadRecordsCount(accountId, projectId, 'waste', 'assignedToMe', {
          assignedTo: userUuid
        })
      )
    }
  }, [dispatch, accountId, projectId, userUuid])

  const wasteCounts = useSelector((state: any) => state.home.waste)

  const updateGlobalDateRangeAndGoToRecords = (period: string) => {
    let startDate: string | null = null
    const endDate = moment().endOf('day').toISOString()

    if (period === 'today') {
      startDate = moment().startOf('day').toISOString()
    } else if (period === 'last30Days') {
      startDate = moment().subtract(30, 'days').startOf('day').toISOString()
    } else {
      startDate = '2018-01-01T00:00:00.000Z'
    }

    const wasteFiltersString = sessionStorage.getItem('waste-filters') || '{}'
    const wasteFilters = JSON.parse(wasteFiltersString)

    // If assignedToMe update waste-filters in session storage, else remove assignedTo filter
    if (period === 'assignedToMe' && userUuid) {
      wasteFilters.assignedTo = [userUuid]
      sessionStorage.setItem('waste-filters', JSON.stringify(wasteFilters))
    } else if (wasteFilters.assignedTo) {
      delete wasteFilters.assignedTo
      sessionStorage.setItem('waste-filters', JSON.stringify(wasteFilters))
    }

    dispatch(
      datePickerChanged(
        {
          startDate,
          endDate
        },
        'global'
      )
    )

    if (accountId && projectId) {
      setTimeout(() => {
        navigate(
          generatePath(routes.WASTE_TABLE, {
            accountId: accountId,
            projectId: projectId
          })
        )
      }, 100)
    }
  }

  return (
    <>
      <TitleBar>
        <TitleBarIcon style={{ marginTop: 4 }}>
          <icons.Modules.Waste />
        </TitleBarIcon>
        <Title level={4}>Waste Records</Title>
      </TitleBar>
      <Tiles>
        <Tile onClick={() => updateGlobalDateRangeAndGoToRecords('total')}>
          <TileRow>
            <Title level={5}>Total</Title>
          </TileRow>
          <TileRow>
            {wasteCounts.total.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(wasteCounts?.total.count)}
              </TileNumber>
            )}
          </TileRow>
        </Tile>

        <Tile onClick={() => updateGlobalDateRangeAndGoToRecords('today')}>
          <TileRow>
            <Title level={5}>Today</Title>
          </TileRow>
          <TileRow>
            {wasteCounts.today.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(wasteCounts?.today.count)}
              </TileNumber>
            )}
          </TileRow>
        </Tile>

        <Tile onClick={() => updateGlobalDateRangeAndGoToRecords('last30Days')}>
          <TileRow>
            <Title level={5}>Last 30 days</Title>
          </TileRow>
          <TileRow>
            {wasteCounts.last30Days.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(wasteCounts?.last30Days.count)}
              </TileNumber>
            )}
          </TileRow>
        </Tile>

        <Tile
          onClick={() => updateGlobalDateRangeAndGoToRecords('assignedToMe')}
        >
          <TileRow>
            <Title level={5}>Assigned to you</Title>
          </TileRow>
          <TileRow>
            {wasteCounts.assignedToMe.loading ? (
              <SmallSpinner />
            ) : (
              <TileNumber>
                {new Intl.NumberFormat().format(
                  wasteCounts?.assignedToMe.count
                )}
              </TileNumber>
            )}
          </TileRow>
        </Tile>
      </Tiles>
    </>
  )
}
